import React from 'react';
import PageSEO from "@/components/common/PageSEO";
import Spacing from "@/components/common/Spacing";
import './legal-pages.css';

const TermeniConditii: React.FC = () => {
  return (
	<>
	  <PageSEO section="legal" keyName="termeni-conditii" />
	  
	  <main className="legal-page">
		<div className="container">
		  <Spacing size={6} />
		  
		  <div className="legal-content">
			<h1>TERMENI ȘI CONDIȚII</h1>
			<p className="last-updated"><strong>Data ultimei actualizări: {new Date().toLocaleDateString('ro-RO')}</strong></p>

			<section>
			  <h2>2.1 Definiții</h2>
			  <ul>
				<li><strong>"Compania"</strong> - ITastic.ro SRL, care operează sub brandul comercial "Pixado"</li>
				<li><strong>"Servicii"</strong> - toate serviciile oferite prin pixado.ro și ccshop.pixado.ro</li>
				<li><strong>"Client"</strong> - persoana fizică sau juridică care utilizează serviciile noastre</li>
				<li><strong>"Site principal"</strong> - pixado.ro</li>
				<li><strong>"Shop online"</strong> - ccshop.pixado.ro</li>
			  </ul>
			</section>

			<section>
			  <h2>2.2 Acceptarea termenilor</h2>
			  <p>Prin utilizarea serviciilor noastre (inclusiv vizitarea site-urilor pixado.ro și ccshop.pixado.ro), acceptați acești termeni și condiții în întregime. Dacă nu sunteți de acord cu oricare dintre aceste prevederi, vă rugăm să nu utilizați serviciile noastre.</p>
			</section>

			<section>
			  <h2>2.3 Date despre companie</h2>
			  <div className="contact-info">
				<p><strong>Denumire:</strong> ITastic.ro SRL</p>
				<p><strong>Brand comercial:</strong> Pixado</p>
				<p><strong>Sediul social:</strong> Timișoara, România</p>
				<p><strong>Email:</strong> contact@pixado.ro</p>
				<p><strong>Telefon:</strong> +40 745 371 620</p>
			  </div>
			</section>

			<section>
			  <h2>2.4 Serviciile oferite</h2>
			  <p>Pixado oferă exclusiv servicii digitale personalizate:</p>
			  
			  <div className="data-category">
				<h3>Servicii de design și dezvoltare:</h3>
				<ul>
				  <li><strong>Web Design:</strong> Proiectare și dezvoltare website-uri responsive</li>
				  <li><strong>E-commerce:</strong> Dezvoltare magazine online personalizate pentru clienți</li>
				  <li><strong>Branding:</strong> Logo design, identitate vizuală, manuale de brand</li>
				  <li><strong>Marketing digital:</strong> SEO, SMM, advertising, video marketing</li>
				</ul>
			  </div>

			  <div className="data-category">
				<h3>Platforma DEMO (ccshop.pixado.ro):</h3>
				<ul>
				  <li><strong>Scop:</strong> Demonstrarea capabilităților noastre în dezvoltarea de magazine online</li>
				  <li><strong>Funcționalitate:</strong> Simularea procesului de cumpărături - FĂRĂ tranzacții reale</li>
				  <li><strong>Utilizare:</strong> Lead generation și prezentarea portofoliului</li>
				  <li><strong>Important:</strong> Nu se vind produse reale pe această platformă!</li>
				</ul>
			  </div>
			</section>

			<section>
			  <h2>2.5 Contractarea serviciilor</h2>
			  <ul>
				<li><strong>Servicii personalizate:</strong> Se contractează exclusiv prin email, telefon sau formular de contact</li>
				<li><strong>Platforma DEMO:</strong> Nu implică contractarea - doar demonstrare și lead generation</li>
				<li><strong>Oferte:</strong> Sunt valabile 30 de zile de la emitere</li>
				<li><strong>Confirmare:</strong> Contractul se consideră încheiat doar la semnarea acordului scris</li>
				<li><strong>Nu există vânzări automate:</strong> Toate serviciile sunt personalizate și contractate individual</li>
			  </ul>
			</section>

			<section>
			  <h2>2.6 Prețuri și plăți</h2>
			  <ul>
				<li><strong>Moneda:</strong> Prețurile sunt exprimate în RON și EUR, TVA inclus</li>
				<li><strong>Metode de plată:</strong> Transfer bancar, PayPal (doar pentru contractele de servicii)</li>
				<li><strong>Plăți în avans:</strong> Pentru servicii personalizate se solicită avans de 50%</li>
				<li><strong>Întârzieri:</strong> În caz de întârziere la plată, se pot percepe dobânzi penalizatoare de 0.1% pe zi</li>
				<li><strong>Facturare:</strong> Toate contractele sunt facturate conform legislației românești</li>
				<li><strong>Important:</strong> ccshop.pixado.ro nu procesează plăți reale - este doar DEMO</li>
			  </ul>
			</section>

			<section>
			  <h2>2.7 Livrarea serviciilor</h2>
			  
			  <div className="data-category">
				<h3>Servicii personalizate:</h3>
				<ul>
				  <li>Termenele de livrare sunt specificate în contract</li>
				  <li>Livrarea se face prin email, platformă dedicată sau transfer de fișiere</li>
				  <li>Clientul are obligația să verifice și să confirme primirea în maxim 7 zile</li>
				  <li>Revizuirile și modificările se fac conform contractului semnat</li>
				</ul>
			  </div>

			  <div className="data-category">
				<h3>Platforma DEMO (ccshop.pixado.ro):</h3>
				<ul>
				  <li>Nu se livrează produse reale - este doar demonstrare</li>
				  <li>Simularea procesului de cumpărare nu implică obligații contractuale</li>
				  <li>Utilizarea platformei este gratuită și în scop informativ</li>
				</ul>
			  </div>
			</section>

			<section>
			  <h2>2.8 Drepturile de proprietate intelectuală</h2>
			  
			  <div className="data-category">
				<h3>Servicii personalizate:</h3>
				<ul>
				  <li>Drepturile de autor asupra materialelor create revin clientului după plata integrală</li>
				  <li>Pixado își rezervă dreptul de a folosi proiectele în portofoliu cu acordul clientului</li>
				  <li>Codul sursă dezvoltat devine proprietatea clientului la finalizarea contractului</li>
				  <li>Clientul primește toate fișierele sursa și documentația tehnică</li>
				</ul>
			  </div>

			  <div className="data-category">
				<h3>Platforma DEMO (ccshop.pixado.ro):</h3>
				<ul>
				  <li>Toate elementele demo rămân proprietatea Pixado</li>
				  <li>Utilizatorii nu dobândesc drepturi asupra codului sau design-ului demo</li>
				  <li>Demo-ul servește exclusiv pentru prezentarea capabilităților noastre</li>
				</ul>
			  </div>

			  <p><strong>Obligația clientului:</strong> Clientul garantează că toate materialele furnizate (texte, imagini, logo-uri) nu încalcă drepturi de proprietate intelectuală ale terților.</p>
			</section>

			<section>
			  <h2>2.9 Responsabilități și limitări</h2>
			  <ul>
				<li><strong>Limitarea răspunderii:</strong> Pixado nu răspunde pentru daune indirecte, pierderi de profit sau daune speciale</li>
				<li><strong>Plafon de răspundere:</strong> Responsabilitatea noastră este limitată la valoarea totală plătită pentru serviciul respectiv</li>
				<li><strong>Forța majoră:</strong> Nu răspundem pentru întârzieri cauzate de evenimente de forță majoră</li>
				<li><strong>Responsabilitatea clientului:</strong> Clientul răspunde pentru acuratețea informațiilor furnizate și respectarea termenilor de plată</li>
				<li><strong>Mentenanța:</strong> Pentru website-uri, mentenanța și actualizările nu sunt incluse în prețul de dezvoltare (cu excepția unor pachete specifice)</li>
			  </ul>
			</section>

			<section>
			  <h2>2.10 Politica de anulare servicii</h2>
			  
			  <div className="data-category">
				<h3>Servicii personalizate:</h3>
				<ul>
				  <li>Serviciile pot fi anulate cu notificare scrisă înainte de începerea lucrărilor</li>
				  <li>După începerea lucrărilor, anularea se face conform contractului semnat</li>
				  <li>În caz de anulare din partea clientului, avansul plătit poate fi reținut ca taxă de anulare</li>
				  <li>În caz de anulare din partea Pixado, avansul se returnează integral</li>
				</ul>
			  </div>

			  <div className="data-category">
				<h3>Platforma DEMO (ccshop.pixado.ro):</h3>
				<ul>
				  <li>Nu există produse de returnat - este doar demonstrare</li>
				  <li>Nu se aplică politici de rambursare pentru că nu se efectuează plăți</li>
				  <li>Utilizarea demo-ului este gratuită și fără obligații</li>
				</ul>
			  </div>
			</section>

			<section>
			  <h2>2.11 Confidențialitate și protecția datelor</h2>
			  <p>Prelucrarea datelor personale se face conform <a href="/politica-confidentialitate">Politicii de Confidențialitate</a> și <a href="/politica-cookies">Politicii de Cookies</a>. Prin acceptarea acestor termeni, confirmați că ați citit și înțeles aceste politici.</p>
			</section>

			<section>
			  <h2>2.12 Utilizarea platformelor</h2>
			  
			  <div className="data-category">
				<h3>Platforma DEMO (ccshop.pixado.ro):</h3>
				<ul>
				  <li>Utilizarea este gratuită și în scop demonstrativ</li>
				  <li>Nu creați conturi reale - datele introduse sunt doar pentru testare</li>
				  <li>Datele de testare nu sunt păstrate permanent</li>
				  <li>Nu încercați să "cumpărați" efectiv produse - nu funcționează!</li>
				</ul>
			  </div>

			  <div className="data-category">
				<h3>Utilizare interzisă pe ambele platforme:</h3>
				<ul>
				  <li>Activități ilegale sau care încalcă drepturile terților</li>
				  <li>Încărcarea de malware, virusi sau cod dăunător</li>
				  <li>Tentative de hacking sau compromitere a securității</li>
				  <li>Spam, phishing sau alte forme de abuz</li>
				  <li>Utilizarea automată prin bot-uri fără aprobare</li>
				</ul>
			  </div>
			</section>

			<section>
			  <h2>2.13 Soluționarea disputelor</h2>
			  <ul>
				<li><strong>Negociere directă:</strong> Încercăm întotdeauna rezolvarea pe cale amiabilă</li>
				<li><strong>Medierea:</strong> În caz de dezacord, acceptăm procedura de mediere</li>
				<li><strong>Jurisdicția:</strong> Disputele nesoluționate se soluționează la instanțele competente din Timișoara, România</li>
				<li><strong>Legea aplicabilă:</strong> Contractele sunt guvernate de legea română</li>
			  </ul>
			</section>

			<section>
			  <h2>2.14 Modificarea termenilor</h2>
			  <p>Acești termeni pot fi modificați pentru a reflecta schimbările în servicii sau cerințele legale. Modificările importante vor fi comunicate cu 30 de zile înainte prin:</p>
			  <ul>
				<li>Email către clienții înregistrați</li>
				<li>Notificare pe site-urile noastre</li>
				<li>Actualizarea datei de modificare</li>
			  </ul>
			  <p>Continuarea utilizării serviciilor după implementarea modificărilor constituie acceptarea noilor termeni.</p>
			</section>

			<section>
			  <h2>2.15 Contact și asistență</h2>
			  <p>Pentru întrebări despre acești termeni și condiții sau pentru asistență:</p>
			  <div className="contact-info">
				<p><strong>Email:</strong> <a href="mailto:contact@pixado.ro">contact@pixado.ro</a></p>
				<p><strong>Telefon:</strong> <a href="tel:+40745371620">+40 745 371 620</a></p>
				<p><strong>Program:</strong> Luni - Vineri, 09:00 - 18:00 (GMT+2)</p>
			  </div>
			</section>
		  </div>
		  
		  <Spacing size={6} />
		</div>
	  </main>
	</>
  );
};

export default TermeniConditii;